import * as _ from 'lodash'
import {BehaviorSubject} from 'rxjs'
import {ASync} from '../PA.Core/Basic/ASync'

import {Subscription} from "rxjs/Subscription";
import {ICannibalizationSetActualsCalculator} from "./PA.Consumption.Services.IF";
import {IMessageProvider, IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {MetricParameters, MetricsParameterSet} from "../PA.Metric.Services/PAMetrics";
import {
  WB_CannibalizationSetProductGroupRow,
  WB_CannibalizationSetProductRow,
  WB_FinishedProductRow
} from "../PA.Core/PAdbSchemaRows";
import {PAMetricServiceClient} from "../PA.Metric.Services/PAMetricServiceClient";
import {
  DetailAttributes, IMetricDetailRow,
  IMetricDetails,
  IMetricDetailsSet,
  IMetrics,
  IMetricsSet
} from "../PA.Metric.Services/PA.Metrics.IF";
import {DateUtils} from "../PA.Core/Basic/Dates";

import {ExecutionSerializer} from "../PA.Core/Basic/ExecutionSerializer"
import {CannibalizationSetBO} from "../PA.Consumption.BusinessObjects/CannibalizationSetBO";
import {ICannibalizationSetChangedEvent} from "../PA.Consumption.Core/PA.Consumption.IF";
import {CannibalizationDataUtils, EquivRatesDictionary} from "../PA.Consumption.Core/CannibalizationDataUtils";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Cannibalization_Set_Product, esWB_Finished_Product} from "../PA.Core/PAdbSchema";


const bDebugSerializers = true

interface ICalcStepOptions {
  bUseProgressProvider?: boolean,
  bUseMessageProvider?: boolean,
  bWriteProductRows?: boolean
}

const CalcStepOptionsDefaults: ICalcStepOptions = {
  bUseProgressProvider: true,
  bUseMessageProvider: false,
  bWriteProductRows: false
}


export class CannibalizationSetActualsCalculator
  implements ICannibalizationSetActualsCalculator {

  private _enabled: boolean
  private aCannibalizationSetBO: CannibalizationSetBO
  private _CalcProgressProvider: IProgressProvider;
  private _CalcMessageProvider: IMessageProvider;
  private _OnCalculateComplete: BehaviorSubject<ICannibalizationSetActualsCalculator>;

  private _CannibalizationSetChangeSubscription: Subscription
  private _CannibalizationSetPGChangeSubscription: Subscription

  private _EquivRates: EquivRatesDictionary

  private _dctProductByWB_PROD_ID: {[id: number]: WB_FinishedProductRow}
  private _dctProductByCnsUPC: {[id:string]: WB_FinishedProductRow}

  private dbContext: PAdbContext

  // For Each Entry point, we need a serializer

  private qsCannibalizationSet_fullCalc: ExecutionSerializer

  constructor(options?: any) {

    this._enabled = true
    this.aCannibalizationSetBO = undefined
    this._CalcMessageProvider = new MessageProvider()
    this._CalcProgressProvider = new ProgressProvider()
    this._OnCalculateComplete = new BehaviorSubject<ICannibalizationSetActualsCalculator>(undefined)

    this._CannibalizationSetChangeSubscription = undefined
    this._CannibalizationSetPGChangeSubscription = undefined

    this._EquivRates = {}
    this._dctProductByWB_PROD_ID = {}
    this._dctProductByCnsUPC = {}

    this.qsCannibalizationSet_fullCalc = new ExecutionSerializer(this, this.CalculateStep_Start.bind(this),
      [{}], 1000, bDebugSerializers)

    this.dbContext = new PAdbContext()

  }

  Register(pCannibalizationSetBO: CannibalizationSetBO): Promise<void> {
    const self = this
    self.UnRegister()

    if (_.isEmpty(pCannibalizationSetBO)) {
      return ASync.resolve()
    }

    // Watch
    //   Date Change  (Event level, Spend Level)
    return new Promise<void>((resolve, error) => {

      self.aCannibalizationSetBO = pCannibalizationSetBO

      self._CannibalizationSetChangeSubscription = self.aCannibalizationSetBO.CannibalizationSetPropertyChanged.subscribe(self.OnCannibalizationSetChange.bind(self))
      self._CannibalizationSetPGChangeSubscription = self.aCannibalizationSetBO.CannibalizationProductGroupPropertyChanged.subscribe(self.OnCannibalizationSetPGChange.bind(self))

      self.qsCannibalizationSet_fullCalc.Name = pCannibalizationSetBO.WB_CannibalizationSet.cif.CANN_NAME + ': qsCannibalizationSet_fullCalc'

      resolve()
    })

  }

  UnRegister() {


    if (this._CannibalizationSetChangeSubscription) {
      this._CannibalizationSetChangeSubscription.unsubscribe()
      this._CannibalizationSetChangeSubscription = undefined
    }

    if (this._CannibalizationSetPGChangeSubscription) {
      this._CannibalizationSetPGChangeSubscription.unsubscribe()
      this._CannibalizationSetPGChangeSubscription = undefined
    }


    this.aCannibalizationSetBO = undefined

  }

  get Enabled(): boolean {
    return this._enabled
  }

  set Enabled(value) {
    this._enabled = value
  }

  get CannibalizationSet(): CannibalizationSetBO {
    return this.aCannibalizationSetBO
  }

  get CalcProgressProvider(): IProgressProvider {
    return this._CalcProgressProvider
  }

  get CalcMessageProvider(): IMessageProvider {
    return this._CalcMessageProvider
  }

  get OnCalculateComplete(): BehaviorSubject<ICannibalizationSetActualsCalculator> {
    return this._OnCalculateComplete
  }


  // Change Events

  //<editor-fold desc="Change Events">


  private OnCannibalizationSetChange(oCannSet: ICannibalizationSetChangedEvent) {
    if (_.isEmpty(oCannSet)) {
      return
    }

    switch (oCannSet.PropertyChanged) {
      case 'EFFECTIVE_START_DT':
      case 'EFFECTIVE_END_DT':
        break;
      case 'Ignored..No':
        this.queueFullCalc(oCannSet.PropertyChanged)
        break;
    }

  }

  private OnCannibalizationSetPGChange(oCannSet: ICannibalizationSetChangedEvent) {
    const self = this

    if (_.isEmpty(oCannSet)) {
      return
    }


    this.CannibalizationSet.WB_CannibalizationSet.WB_CannibalizationSetProductGroupRows[0].cif.VICTIM_EQV


    let bCalc = false
    let sCannTypeId = oCannSet.CannibalizationSetBO.WB_CannibalizationSet.WB_CannibalizationTypeRow.cif.DOMAIN_ITEM_ID

    switch (oCannSet.PropertyChanged) {
      case 'WB_CUST_ID_PLANNING_VICT':
      case 'WB_CUST_ID_PLANNING_AGGR':
      case 'WB_PRDGRP_ID_VICT':
      case 'WB_PRDGRP_ID_AGGR':
      case 'EFFECTIVE_DT_VICT':
      case 'EFFECTIVE_DT_AGGR':
      case 'VICTIM_EQV':
        // Room for optimization here.. ignore updates that are automated in the calc
        console.log(oCannSet.PropertyChanged)
        bCalc = true
        break;
    }

    if(bCalc){
      this.queueFullCalc(oCannSet.PropertyChanged)
    }

  }

  static syncAndCheckCannPGRowProperties(aCannibalizationSetBO: CannibalizationSetBO,
                                         aRow: WB_CannibalizationSetProductGroupRow): boolean {

    let aPlanningCustomer = _.first(aCannibalizationSetBO.PlanningCustomer_WB_CustomerRows)
    if(_.isEmpty(aPlanningCustomer)){ return false }

    switch (aCannibalizationSetBO.WB_CannibalizationSet.WB_CannibalizationTypeRow.cif.DOMAIN_ITEM_ID) {
      case "PackSize":
      case "CrossBrand":
        if(aRow.cif.WB_CUST_ID_PLANNING_AGGR != aPlanningCustomer.cif.WB_CUST_ID){
          aRow.cif.WB_CUST_ID_PLANNING_AGGR = aPlanningCustomer.cif.WB_CUST_ID
        }
        if(aRow.cif.WB_CUST_ID_PLANNING_VICT != aPlanningCustomer.cif.WB_CUST_ID){
          aRow.cif.WB_CUST_ID_PLANNING_VICT = aPlanningCustomer.cif.WB_CUST_ID
        }
        if(aRow.cif.EFFECTIVE_DT_AGGR != aRow.cif.EFFECTIVE_DT_VICT){
          aRow.cif.EFFECTIVE_DT_AGGR = aRow.cif.EFFECTIVE_DT_VICT
        }
        break;

      case "CrossRetailer":
        if(aRow.cif.EFFECTIVE_DT_AGGR != aRow.cif.EFFECTIVE_DT_VICT){
          aRow.cif.EFFECTIVE_DT_AGGR = aRow.cif.EFFECTIVE_DT_VICT
        }
        break;

      case "PantryLoading":
        if(aRow.cif.WB_CUST_ID_PLANNING_AGGR != aPlanningCustomer.cif.WB_CUST_ID){
          aRow.cif.WB_CUST_ID_PLANNING_AGGR = aPlanningCustomer.cif.WB_CUST_ID
        }
        if(aRow.cif.WB_CUST_ID_PLANNING_VICT != aPlanningCustomer.cif.WB_CUST_ID){
          aRow.cif.WB_CUST_ID_PLANNING_VICT = aPlanningCustomer.cif.WB_CUST_ID
        }
        if(aRow.cif.WB_PRDGRP_ID_AGGR != aRow.cif.WB_PRDGRP_ID_VICT){
          aRow.cif.WB_PRDGRP_ID_AGGR = aRow.cif.WB_PRDGRP_ID_VICT
        }
        break;

      case "UserDefined":
        break;

      default:
        break;
    }

    // Now Check all the fields for Valid Values
    let vctmPlanningCustomer = aRow.cif.WB_CUST_ID_PLANNING_AGGR
    let vctmProductGroup = aRow.cif.WB_PRDGRP_ID_VICT
    let vctmDate = DateUtils.convertFromSAPBW(aRow.cif.EFFECTIVE_DT_VICT)

    let aggrPlanningCustomer = aRow.cif.WB_CUST_ID_PLANNING_AGGR
    let aggrProductGroup = aRow.cif.WB_PRDGRP_ID_AGGR
    let aggrDate = DateUtils.convertFromSAPBW(aRow.cif.EFFECTIVE_DT_AGGR)

    switch (true) {
      case (!_.isNumber(vctmPlanningCustomer)) || (vctmPlanningCustomer == 0) :
      case (!_.isNumber(vctmProductGroup)) || (vctmProductGroup == 0) :
      case !(_.isDate(vctmDate)):
      case (!_.isNumber(aggrPlanningCustomer)) || (aggrPlanningCustomer == 0) :
      case (!_.isNumber(aggrProductGroup)) || (aggrProductGroup == 0) :
      case !(_.isDate(aggrDate)):
        return false
        break;

      default:
        break;
    }

    return true
  }


  Calculate(): Promise<void> {
    //

    return this.CalculateStep_Start({
      bUseProgressProvider: true,
      bUseMessageProvider: true,
      bWriteProductRows: true
    })

  }

  QueueCalculate(): void {
    //
    this.qsCannibalizationSet_fullCalc.Run({bSkipDebounce: true})
  }


  //<editor-fold desc="Queue Calls">

  private queueFullCalc(sPropertyName: string) {
    this.qsCannibalizationSet_fullCalc.Run()
  }



  //</editor-fold>

  //<editor-fold desc="Calc Steps">

  private CalculateStep_Start(options?: ICalcStepOptions): Promise<void> {
    const self = this

    let opts: ICalcStepOptions = {}
    _.defaults(opts, options || {}, CalcStepOptionsDefaults)

    if (_.isEmpty(this.aCannibalizationSetBO)) {
      return ASync.resolve()
    }

    return new Promise<void>((resolve, error) => {

      let aMtrcParamSet: MetricsParameterSet = undefined
      let aMtrcSet: IMetricsSet = undefined
      let aMtrcDtlSet: IMetricDetailsSet = undefined

      let aMetricServiceClient = new PAMetricServiceClient()

      if (opts.bUseProgressProvider) {
        self.CalcProgressProvider.start("CannibalizationSet Calc..")
      }

      self.syncSupportingData()
        .then((ignore) => {
          return self.createMetricParametersSet()
        }).then((aMps) => {
          aMtrcParamSet = aMps

          return aMetricServiceClient.calculateMetricSet(aMtrcParamSet)
        }).then((ms) => {
          aMtrcSet = ms
          return aMetricServiceClient.calculateMetricDetailsSet(aMtrcParamSet, {Attributes: [DetailAttributes.ConsumerUPC]})
        }).then((mds) => {
          aMtrcDtlSet = mds

          return self.processMetricResults(aMtrcSet, aMtrcDtlSet, opts)
        }).then((ignore) => {
          if (opts.bUseProgressProvider) {
            self.CalcProgressProvider.finish()
          }
          self._OnCalculateComplete.next(self)

          resolve()
        }).catch((err) => {
          if (opts.bUseProgressProvider) {
            self.CalcProgressProvider.exception(err)
          }
          error(err)
        })

    })

  }


  syncSupportingData(): Promise<void> {
    const self = this

   return new Promise<void>((resolve, error) => {

     let dctPGs: {[id: number]: number} = {}

     if(_.isEmpty(self.CannibalizationSet)){
       resolve()
       return
     }

     _.forEach(self.CannibalizationSet.AffinityGroup_WB_ProductGroupRows, (aRow) => {
       if(!(aRow.cif.WB_PRDGRP_ID in dctPGs)){
         dctPGs[aRow.cif.WB_PRDGRP_ID] = aRow.cif.WB_PRDGRP_ID
       }
     })

     _.forEach(self.CannibalizationSet.WB_CannibalizationSet.WB_CannibalizationSetProductGroupRows,(aRow) => {
        if(!aRow.isActive){ return }

        if(_.isNumber(aRow.cif.WB_PRDGRP_ID_VICT) &&  (aRow.cif.WB_PRDGRP_ID_VICT != 0)){
          if(!(aRow.cif.WB_PRDGRP_ID_VICT in dctPGs)){
            dctPGs[aRow.cif.WB_PRDGRP_ID_VICT] = aRow.cif.WB_PRDGRP_ID_VICT
          }
        }

        if(_.isNumber(aRow.cif.WB_PRDGRP_ID_AGGR) &&  (aRow.cif.WB_PRDGRP_ID_AGGR != 0)){
          if(!(aRow.cif.WB_PRDGRP_ID_AGGR in dctPGs)){
            dctPGs[aRow.cif.WB_PRDGRP_ID_AGGR] = aRow.cif.WB_PRDGRP_ID_AGGR
          }
        }
     })

     let missingPGIds: number[] = []

     _.forEach(_.values(dctPGs), (aKey: number)=> {
       if(!(aKey in self._EquivRates)){
         missingPGIds.push(aKey)
       }
     })


     let loadEqvRates: Promise<any>
     if(_.isEmpty(missingPGIds)){
       loadEqvRates = ASync.resolve({})
     } else {
       loadEqvRates = CannibalizationDataUtils.getProductGroupProductEqvRates(missingPGIds)
     }

     loadEqvRates
       .then((newDct) => {
         _.forEach(_.keys(newDct), (aKey: number) => {
           self._EquivRates[aKey] = newDct[aKey]
         })

         // figure out missing product
         let dctMissingProducts: {[id: number]: number} ={}
         _.forEach(_.keys(self._EquivRates),(aPGId: number) => {
          _.forEach(self._EquivRates[aPGId], (value: any, key: any) => {
            if(!(key in self._dctProductByWB_PROD_ID)){
              dctMissingProducts[key] = key
            }
          })
         })

         if(_.isEmpty(dctMissingProducts)){
           resolve()
           return
         }

         let arrMissingPrds = _.values(dctMissingProducts)

         return self.dbContext.findUsingCache(esWB_Finished_Product, arrMissingPrds)
       })
       .then((arrFinishedProducts: WB_FinishedProductRow[]) => {
         _.forEach(arrFinishedProducts, (aRow) => {
           if(!(aRow.cif.WB_PROD_ID in self._dctProductByWB_PROD_ID)){
             self._dctProductByWB_PROD_ID[aRow.cif.WB_PROD_ID] = aRow
           }
         })

         self._dctProductByCnsUPC = _.keyBy(_.values(self._dctProductByWB_PROD_ID), (aRow: WB_FinishedProductRow) => { return aRow.cif.PRODUCT_ID})

         resolve()
       })
       .catch((err) => {
         error(err)
       })


   })

  }


  createMetricParametersSet(): Promise<MetricsParameterSet> {
     const self = this

     let returnValue = new MetricsParameterSet()

     if(_.isEmpty(self.CannibalizationSet)) {
       return ASync.resolve(returnValue)
     }

     return new Promise<MetricsParameterSet>((resolve, error) => {

       let arrWB_CannPG = _.filter(self.CannibalizationSet.WB_CannibalizationSet.WB_CannibalizationSetProductGroupRows, 'isActive')

       _.forEach(arrWB_CannPG, (aCPG)=> {

         if(!CannibalizationSetActualsCalculator.syncAndCheckCannPGRowProperties(self.CannibalizationSet, aCPG)){
           return
         }

         let vctmPlanningCustomer = aCPG.cif.WB_CUST_ID_PLANNING_AGGR
         let vctmProductGroup = aCPG.cif.WB_PRDGRP_ID_VICT
         let vctmDate = DateUtils.convertFromSAPBW(aCPG.cif.EFFECTIVE_DT_VICT)

         let aggrPlanningCustomer = aCPG.cif.WB_CUST_ID_PLANNING_AGGR
         let aggrProductGroup = aCPG.cif.WB_PRDGRP_ID_AGGR
         let aggrDate = DateUtils.convertFromSAPBW(aCPG.cif.EFFECTIVE_DT_AGGR)

         if(!(aggrProductGroup in self._EquivRates)){ return }

         if(!(vctmProductGroup in self._EquivRates)){ return }

         // Aggregate
         let aggrMtrcParameters = new MetricParameters()
         aggrMtrcParameters.MetricParameterId = 'AGGR-' + aCPG.cif.WB_CANNPG_ID
         aggrMtrcParameters.bCalculateIntersection = false
         aggrMtrcParameters.PlanningCustomers = [aggrPlanningCustomer]
         aggrMtrcParameters.SourceCustomers = []
         aggrMtrcParameters.ConsumerProductUPCs = []
         aggrMtrcParameters.FinishedProducts = _.map(_.keys(self._EquivRates[aggrProductGroup]), (sKey) => { return _.toNumber(sKey)})
         aggrMtrcParameters.InStoreStartDt = DateUtils.addDays(aggrDate,-6)
         aggrMtrcParameters.InStoreEndDt = aggrDate
         aggrMtrcParameters.Sources = []
         returnValue[aggrMtrcParameters.MetricParameterId] = aggrMtrcParameters


         let vctmMtrcParameter = new MetricParameters()
         vctmMtrcParameter.MetricParameterId = 'VCTM-' + aCPG.cif.WB_CANNPG_ID
         vctmMtrcParameter.bCalculateIntersection = false
         vctmMtrcParameter.PlanningCustomers = [vctmPlanningCustomer]
         vctmMtrcParameter.SourceCustomers = []
         vctmMtrcParameter.ConsumerProductUPCs = []
         vctmMtrcParameter.FinishedProducts =_.map(_.keys(self._EquivRates[vctmProductGroup]), (sKey) => { return _.toNumber(sKey)})
         vctmMtrcParameter.InStoreStartDt = DateUtils.addDays(vctmDate,-6)
         vctmMtrcParameter.InStoreEndDt = vctmDate
         vctmMtrcParameter.Sources = []
         returnValue[vctmMtrcParameter.MetricParameterId] = vctmMtrcParameter

       })

       resolve(returnValue)
     })

  }


  processMetricResults(ms: IMetricsSet, mds: IMetricDetailsSet, opts?: ICalcStepOptions): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {

      if(_.isEmpty(ms) || _.isEmpty(mds)){
        resolve()
        return
      }

      let arrWB_CannPG = _.filter(self.CannibalizationSet.WB_CannibalizationSet.WB_CannibalizationSetProductGroupRows,'isActive')

      async function CalcEachCannPG(){
        let idx = 0
        for(idx = 0;idx < arrWB_CannPG.length; idx++){
          // Get Parameters from Metric Detail Set
          let aRow = arrWB_CannPG[idx]
          let aggrKey = 'AGGR-' + aRow.cif.WB_CANNPG_ID
          let vctmKey = 'VCTM-' + aRow.cif.WB_CANNPG_ID

          await self.applyMetricResultsToCannibalizationSetPG(aRow, ms[aggrKey], ms[vctmKey], mds[aggrKey], mds[vctmKey], opts)

        }


      }

      CalcEachCannPG()
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })

    })
  }


  applyMetricResultsToCannibalizationSetPG(drWB_CSPG: WB_CannibalizationSetProductGroupRow,
                                           aggrMtrcs: IMetrics,         vctmMtrcs: IMetrics,
                                           aggrMtrcDts: IMetricDetails, vctmMtrcDts: IMetricDetails,
                                           opts?: ICalcStepOptions ): Promise<void>{
    const self = this

    return new Promise<void>((resolve, error) => {
      //
      if(_.isEmpty(drWB_CSPG) || _.isEmpty(aggrMtrcs) || _.isEmpty(aggrMtrcDts) || _.isEmpty(vctmMtrcs) || _.isEmpty(vctmMtrcDts)  ){
        resolve()
        return
      }

      //
      drWB_CSPG.cif.AGGR_TOTAL_UNITS = aggrMtrcs.CNSMP_TOTAL_UNITS
      drWB_CSPG.cif.AGGR_TOTAL_RTLSLS = aggrMtrcs.CNSMP_TOTAL_RTLSLS
      drWB_CSPG.cif.AGGR_TOTAL_LSTSLS = aggrMtrcs.CNSMP_TOTAL_LISTSLS
      drWB_CSPG.cif.AGGR_TOTAL_PROFIT = aggrMtrcs.CNSMP_TOTAL_PRFTCNTRB

      drWB_CSPG.cif.AGGR_BASE_UNITS = aggrMtrcs.CNSMP_BASE_UNITS + aggrMtrcs.CNSMP_EDLP_UNITS
      drWB_CSPG.cif.AGGR_BASE_RTLSLS = aggrMtrcs.CNSMP_BASE_RTLSLS + aggrMtrcs.CNSMP_EDLP_RTLSLS
      drWB_CSPG.cif.AGGR_BASE_LSTSLS = aggrMtrcs.CNSMP_BASE_LISTSLS + aggrMtrcs.CNSMP_EDLP_LISTSLS
      drWB_CSPG.cif.AGGR_BASE_PROFIT = aggrMtrcs.CNSMP_BASE_PRFTCNTRB + aggrMtrcs.CNSMP_EDLP_PRFTCNTRB

      drWB_CSPG.cif.AGGR_INCR_UNITS = aggrMtrcs.CNSMP_INCR_UNITS
      drWB_CSPG.cif.AGGR_INCR_RTLSLS = aggrMtrcs.CNSMP_INCR_RTLSLS
      drWB_CSPG.cif.AGGR_INCR_LSTSLS = aggrMtrcs.CNSMP_INCR_LISTSLS
      drWB_CSPG.cif.AGGR_INCR_PROFIT = aggrMtrcs.CNSMP_INCR_PRFTCNTRB

      drWB_CSPG.cif.ANY_DISPLAY_WO_FEAT_ACV = aggrMtrcs.MERCH_DISPLAYONLY_ACV_PCNT
      drWB_CSPG.cif.ANY_FEAT_DISPLAY_ACV = aggrMtrcs.MERCH_FEATUREDISPLAY_ACV_PCNT
      drWB_CSPG.cif.ANY_FEAT_WO_DISPLAY_ACV = aggrMtrcs.MERCH_FEATUREONLY_ACV_PCNT
      drWB_CSPG.cif.PRICE_DECREASE_ACV = aggrMtrcs.MERCH_TPRONLY_ACV_PCNT
      drWB_CSPG.cif.ANY_PROMO_ACV = aggrMtrcs.MERCH_PROMOTED_ACV_PCNT


      //
      // Determine the Victim Eqiv Volume
      function calcVolumeTotals(mtrcDts: IMetricDetails, prdGrpId: number) {
        let returnValue = {
          TOTAL_EQV: 0,
          TOTAL_UNITS: 0,
          TOTAL_RTLSLS: 0,
          TOTAL_LSTSLS: 0,
          TOTAL_PROFIT: 0,
          INCR_EQV: 0,
          INCR_UNITS: 0,
          INCR_RTLSLS: 0,
          INCR_LSTSLS: 0,
          INCR_PROFIT: 0,

        }

        let dctEqvRates = self._EquivRates[prdGrpId]
        _.forEach(mtrcDts.DetailRows, (aRow) => {
          if(aRow.ConsumerProductUPC in self._dctProductByCnsUPC){
            let wbPrdRow = self._dctProductByCnsUPC[aRow.ConsumerProductUPC]
            let anEqvRate = dctEqvRates[wbPrdRow.cif.WB_PROD_ID] || 0

            returnValue.TOTAL_EQV += aRow.Metrics.CNSMP_TOTAL_UNITS * anEqvRate
            returnValue.TOTAL_UNITS += aRow.Metrics.CNSMP_TOTAL_UNITS
            returnValue.TOTAL_RTLSLS += aRow.Metrics.CNSMP_TOTAL_RTLSLS
            returnValue.TOTAL_LSTSLS += aRow.Metrics.CNSMP_TOTAL_LISTSLS
            returnValue.TOTAL_PROFIT += aRow.Metrics.CNSMP_TOTAL_PRFTCNTRB

            returnValue.INCR_EQV += aRow.Metrics.CNSMP_INCR_UNITS * anEqvRate
            returnValue.INCR_UNITS += aRow.Metrics.CNSMP_INCR_UNITS
            returnValue.INCR_RTLSLS += aRow.Metrics.CNSMP_INCR_RTLSLS
            returnValue.INCR_LSTSLS += aRow.Metrics.CNSMP_INCR_LISTSLS
            returnValue.INCR_PROFIT += aRow.Metrics.CNSMP_INCR_PRFTCNTRB

          }
        })

        return returnValue

      }

      let vctmTotals = calcVolumeTotals(vctmMtrcDts, drWB_CSPG.cif.WB_PRDGRP_ID_VICT)
      let aggrTotals = calcVolumeTotals(aggrMtrcDts, drWB_CSPG.cif.WB_PRDGRP_ID_AGGR)

      if(vctmTotals.TOTAL_EQV > 0){
        drWB_CSPG.cif.VICTIM_UNITS = drWB_CSPG.cif.VICTIM_EQV * vctmTotals.TOTAL_UNITS/ vctmTotals.TOTAL_EQV
        drWB_CSPG.cif.VICTIM_RTLSLS = drWB_CSPG.cif.VICTIM_EQV * vctmTotals.TOTAL_RTLSLS / vctmTotals.TOTAL_EQV
        drWB_CSPG.cif.VICTIM_LSTSLS = drWB_CSPG.cif.VICTIM_EQV * vctmTotals.TOTAL_LSTSLS/ vctmTotals.TOTAL_EQV
        drWB_CSPG.cif.VICTIM_PROFIT = drWB_CSPG.cif.VICTIM_EQV * vctmTotals.TOTAL_PROFIT/ vctmTotals.TOTAL_EQV
      } else {
        drWB_CSPG.cif.VICTIM_UNITS = 0
        drWB_CSPG.cif.VICTIM_RTLSLS = 0
        drWB_CSPG.cif.VICTIM_LSTSLS = 0
        drWB_CSPG.cif.VICTIM_PROFIT = 0
      }

      if(aggrTotals.TOTAL_EQV > 0){
        drWB_CSPG.cif.AGGR_UNITS = drWB_CSPG.cif.VICTIM_EQV * aggrTotals.TOTAL_UNITS/ aggrTotals.TOTAL_EQV
        drWB_CSPG.cif.AGGR_RTLSLS = drWB_CSPG.cif.VICTIM_EQV * aggrTotals.TOTAL_RTLSLS / aggrTotals.TOTAL_EQV
        drWB_CSPG.cif.AGGR_LSTSLS = drWB_CSPG.cif.VICTIM_EQV * aggrTotals.TOTAL_LSTSLS/ aggrTotals.TOTAL_EQV
        drWB_CSPG.cif.AGGR_PROFIT = drWB_CSPG.cif.VICTIM_EQV * aggrTotals.TOTAL_PROFIT/ aggrTotals.TOTAL_EQV
      } else {
        drWB_CSPG.cif.AGGR_UNITS = 0
        drWB_CSPG.cif.AGGR_RTLSLS = 0
        drWB_CSPG.cif.AGGR_LSTSLS = 0
        drWB_CSPG.cif.AGGR_PROFIT = 0
      }

      if(!opts.bWriteProductRows) {
        resolve()
        return
      }

      // Allocate Products
      async function CreateProductAllocation(aPrdGrpId: number,  sRole: string,mtrcDts: IMetricDetails, aggMetrics: typeof vctmTotals) {

        //
        // create list of
        let dctDetailRowByUPC = _.keyBy(mtrcDts.DetailRows, (adr: IMetricDetailRow) => {
          return adr.ConsumerProductUPC
        })
        let dctEqvRates = self._EquivRates[aPrdGrpId]
        let dctLogicalKeyExists: { [id: string]: boolean } = {}
        let dctUPCsToAdd = _.clone(dctDetailRowByUPC)

        // A. Remove Extra, determine what needs to be added
        let arrRows = _.filter(drWB_CSPG.WB_CannibalizationSetProductRows, (aRow: WB_CannibalizationSetProductRow) => { return aRow.isActive && (aRow.cif.PRDGRP_ROLE == sRole)})
        let idx: number
        for(idx = 0;idx < arrRows.length; idx++){
          //
          let aPrdRow = arrRows[idx]
          let sLogicalKey = sRole + aPrdRow.cif.WB_PROD_ID

          // check for duplicate
          if((sLogicalKey in dctLogicalKeyExists) || (aPrdRow.cif.WB_PROD_ID == 0)){
            aPrdRow.markDeleted()
            continue;
          }

          dctLogicalKeyExists[sLogicalKey] = true

          let wbPrdRow = self._dctProductByWB_PROD_ID[aPrdRow.cif.WB_PROD_ID]
          if(_.isEmpty(wbPrdRow)){
            aPrdRow.markDeleted()
            continue;
          }

          let sUPC = wbPrdRow.cif.CONSUMER_PRODUCT_UPC
          if(!(sUPC in dctDetailRowByUPC)){
            aPrdRow.markDeleted()
          }

          if(sUPC in dctUPCsToAdd){
            delete dctUPCsToAdd[sUPC]
          }
        }

        // B. Add Missing
        let arrUPCsToAdd = _.keys(dctUPCsToAdd)
        for(idx = 0; idx < arrUPCsToAdd.length; idx++){
          let sUPC = arrUPCsToAdd[idx]
          let prdRow = self._dctProductByCnsUPC[sUPC]
          if(_.isEmpty(prdRow)){ continue }

          // @ts-ignore
          let newCannPrdRow: WB_CannibalizationSetProductRow = await self.CannibalizationSet.dbContext.createRecordWithKey(esWB_Cannibalization_Set_Product)
          newCannPrdRow.setDefaults()
          newCannPrdRow.cif.WB_CANNPG_ID = drWB_CSPG.cif.WB_CANNPG_ID
          newCannPrdRow.cif.WB_PROD_ID = prdRow.cif.WB_PROD_ID
          newCannPrdRow.cif.PRDGRP_ROLE = sRole
          self.CannibalizationSet.dbContext.add(esWB_Cannibalization_Set_Product, newCannPrdRow)

        }

        // C. Update Allocation/ Date
        arrRows = _.filter(drWB_CSPG.WB_CannibalizationSetProductRows, (aRow: WB_CannibalizationSetProductRow) => { return aRow.isActive && (aRow.cif.PRDGRP_ROLE == sRole)})

        for(idx = 0;idx < arrRows.length;idx++){
          let aCannPrdRow: WB_CannibalizationSetProductRow = arrRows[idx]
          let wbPrdRow = self._dctProductByWB_PROD_ID[aCannPrdRow.cif.WB_PROD_ID]
          if(_.isEmpty(wbPrdRow)){continue}
          let mdRow = dctDetailRowByUPC[wbPrdRow.cif.CONSUMER_PRODUCT_UPC]
          if(_.isEmpty(mdRow)){continue}
          let anEqvRate = dctEqvRates[wbPrdRow.cif.WB_PROD_ID] || 0
          let TotalEqvVolume = anEqvRate * mdRow.Metrics.CNSMP_TOTAL_UNITS
          let IncrEqvVolume =  anEqvRate * mdRow.Metrics.CNSMP_INCR_UNITS

          let scaleFactor = 0
          if(sRole == "Victim"){
            aCannPrdRow.cif.EFFECTIVE_DT = drWB_CSPG.cif.EFFECTIVE_DT_VICT
            switch(true){
              case (vctmTotals.TOTAL_EQV > 0):
                scaleFactor = TotalEqvVolume / vctmTotals.TOTAL_EQV
                break;
              case (vctmTotals.TOTAL_UNITS > 0):
                scaleFactor = mdRow.Metrics.CNSMP_TOTAL_UNITS / vctmTotals.TOTAL_UNITS
                break;
            }
          } else {
            aCannPrdRow.cif.EFFECTIVE_DT = drWB_CSPG.cif.EFFECTIVE_DT_AGGR
            switch(true){
              case (aggrTotals.INCR_EQV > 0):
                scaleFactor = IncrEqvVolume / aggrTotals.INCR_EQV
                break;
              case (aggrTotals.INCR_UNITS > 0):
                scaleFactor = (mdRow.Metrics.CNSMP_INCR_UNITS || 0) / aggrTotals.INCR_UNITS
                break;
              case (aggrTotals.TOTAL_EQV > 0):
                scaleFactor = TotalEqvVolume / aggrTotals.TOTAL_EQV
                break;
              case (aggrTotals.TOTAL_UNITS > 0):
                scaleFactor = mdRow.Metrics.CNSMP_TOTAL_UNITS / aggrTotals.TOTAL_UNITS
                break;
            }
          }

          aCannPrdRow.cif.VICTIM_EQV = scaleFactor * drWB_CSPG.cif.VICTIM_EQV || 0
          aCannPrdRow.cif.VICTIM_UNITS = scaleFactor * drWB_CSPG.cif.VICTIM_UNITS || 0
          aCannPrdRow.cif.VICTIM_RTLSLS = scaleFactor * drWB_CSPG.cif.VICTIM_RTLSLS || 0
          aCannPrdRow.cif.VICTIM_LSTSLS = scaleFactor * drWB_CSPG.cif.VICTIM_LSTSLS || 0
          aCannPrdRow.cif.VICTIM_PROFIT = scaleFactor * drWB_CSPG.cif.VICTIM_PROFIT || 0

          aCannPrdRow.cif.AGGR_UNITS = scaleFactor * drWB_CSPG.cif.AGGR_UNITS || 0
          aCannPrdRow.cif.AGGR_RTLSLS = scaleFactor * drWB_CSPG.cif.AGGR_RTLSLS || 0
          aCannPrdRow.cif.AGGR_LSTSLS = scaleFactor * drWB_CSPG.cif.AGGR_LSTSLS || 0
          aCannPrdRow.cif.AGGR_PROFIT = scaleFactor * drWB_CSPG.cif.AGGR_PROFIT || 0

          aCannPrdRow.cif.AGGR_TOTAL_UNITS = mdRow.Metrics.CNSMP_TOTAL_UNITS || 0
          aCannPrdRow.cif.AGGR_TOTAL_RTLSLS = mdRow.Metrics.CNSMP_TOTAL_RTLSLS || 0
          aCannPrdRow.cif.AGGR_TOTAL_LSTSLS = mdRow.Metrics.CNSMP_TOTAL_LISTSLS || 0
          aCannPrdRow.cif.AGGR_TOTAL_PROFIT = mdRow.Metrics.CNSMP_TOTAL_PRFTCNTRB || 0

          aCannPrdRow.cif.AGGR_BASE_UNITS = (mdRow.Metrics.CNSMP_BASE_UNITS || 0) + (mdRow.Metrics.CNSMP_EDLP_UNITS || 0)
          aCannPrdRow.cif.AGGR_BASE_RTLSLS = (mdRow.Metrics.CNSMP_BASE_RTLSLS || 0) + (mdRow.Metrics.CNSMP_EDLP_RTLSLS || 0)
          aCannPrdRow.cif.AGGR_BASE_LSTSLS = (mdRow.Metrics.CNSMP_BASE_LISTSLS || 0) +  (mdRow.Metrics.CNSMP_EDLP_LISTSLS || 0)
          aCannPrdRow.cif.AGGR_BASE_PROFIT = (mdRow.Metrics.CNSMP_BASE_PRFTCNTRB || 0) + (mdRow.Metrics.CNSMP_EDLP_PRFTCNTRB || 0)

          aCannPrdRow.cif.AGGR_INCR_UNITS = mdRow.Metrics.CNSMP_INCR_UNITS || 0
          aCannPrdRow.cif.AGGR_INCR_RTLSLS = mdRow.Metrics.CNSMP_INCR_RTLSLS || 0
          aCannPrdRow.cif.AGGR_INCR_LSTSLS = mdRow.Metrics.CNSMP_INCR_LISTSLS || 0
          aCannPrdRow.cif.AGGR_INCR_PROFIT = mdRow.Metrics.CNSMP_INCR_PRFTCNTRB || 0


        }

      }

      CreateProductAllocation(drWB_CSPG.cif.WB_PRDGRP_ID_VICT, "Victim", vctmMtrcDts, vctmTotals)
        .then((ignore) => {
          return CreateProductAllocation(drWB_CSPG.cif.WB_PRDGRP_ID_AGGR, "Aggressor", aggrMtrcDts, aggrTotals)
        }).then((ignore) => {
          resolve()
        }).catch((err) => {
          error(err)
        })
    })

  }



}